import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { LoginAttempt, LoginSession, SuccessLoginResult } from "lib/data/model";


export class LoginApi {

	public static getSession = async (): Promise<LoginSession | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Login`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const session: LoginSession = await ApiHelper.parseResponseBody(response);

				// Process Session Dates
				ApiHelper.parseDateTimeString(session, "startedAt", "expiresAt", "endedAt");

				return session;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static login = async (username: string, password: string): Promise<LoginAttempt | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Login`;

			// Make Request
			const response: Response = await Http.httpPost(url, { username, password });

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const attempt: SuccessLoginResult = await ApiHelper.parseResponseBody(response);

				// Parse Date Strings
				ApiHelper.parseDateTimeString(attempt, "attemptedAt");
				ApiHelper.parseDateTimeString(attempt.session, "startedAt", "expiresAt", "endedAt");

				return attempt;
			}
			else {

				// Switch On Status Code
				switch (response.status) {

					case 401:

						// Parse Response Body
						const attempt: LoginAttempt = await ApiHelper.parseResponseBody(response);

						// Parse Date Strings
						ApiHelper.parseDateTimeString(attempt, "attemptedAt");

						return attempt;
				}
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static logout = async (): Promise<boolean> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Login`;

			// Make Request
			const response: Response = await Http.httpDelete(url, undefined);

			// Check Response
			return response.ok;
		}

		// Return Nothing
		return false;
	}
}
